import { createAsyncThunk } from '@reduxjs/toolkit';
import { IPaymentHistory } from '.';
import {
  APIDataProvider,
  ApiPaths,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TGetPaymentHistories = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
};

const apiDataProvider = new APIDataProvider();

const getPaymentHistoriesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  startDate,
  endDate,
}: TGetPaymentHistories) => {
  let path = `${ApiPaths.paymentHistory}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (startDate) {
    path += `&startDate=${startDate}`;
  }

  if (endDate) {
    path += `&endDate=${endDate}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IPaymentHistory>>
  >(path);

  return response.data;
};

export const getPaymentHistories = createAsyncThunk(
  '/payment-history/list',
  getPaymentHistoriesModule
);
